import React from 'react';
import Header from './Header';

const MyAccountPage = ({ username, onLogout }) => {
    return (
        <div className="min-h-screen bg-gray-100">
            <Header
                isLoggedIn={true}
                username={username}
                onLoginClick={() => { }}
            />

            <main className="container mx-auto p-6">
                <div className="flex justify-center items-center min-h-96">
                    <div className="bg-white rounded-lg shadow-lg p-12 text-center max-w-md w-full">
                        <div className="mb-8">
                            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                </svg>
                            </div>
                            <h1 className="text-3xl font-bold text-gray-800 mb-2" id="congratulations-title" data-test-id="congratulations-title">
                                Congratz, you are logged in!
                            </h1>
                            {username && (
                                <p className="text-lg text-gray-600 mb-6" id="welcome-message" data-test-id="welcome-message">
                                    Welcome back, {username}
                                </p>
                            )}
                        </div>

                        <button
                            onClick={onLogout}
                            className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 logout-button border-2 border-red-800"
                            id="logout-btn"
                            data-test-id="logout-button"
                            style={{
                                backgroundColor: '#dc2626',
                                borderColor: '#991b1b',
                                fontWeight: 'bold'
                            }}
                        >
                            Log Out
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default MyAccountPage;